import React from 'react';

const AsRegister = ({
  formData, setFormData,
  customers, vehicles, engineers,
  isEditing, handleRegister,
  setViewMode, setIsEditing
}) => {
  // 폼 전용 스타일 (기존 As.js에 있던 스타일을 그대로 가져왔습니다)
  const styles = {
    card: { background: 'white', padding: '40px', borderRadius: '24px', boxShadow: '0 10px 30px rgba(0,0,0,0.04)', marginBottom: '35px', border: '1px solid #edf2f7' },
    sectionTitle: { fontSize: '20px', fontWeight: '800', color: '#1e293b', marginBottom: '30px', display: 'flex', alignItems: 'center', gap: '12px' },
    label: { fontSize: '13px', fontWeight: '700', color: '#64748b', display: 'block', marginBottom: '8px' },
    input: { width: '100%', padding: '14px 18px', border: '1px solid #e2e8f0', borderRadius: '12px', fontSize: '14px', boxSizing: 'border-box', outline: 'none' },
    grid4: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '30px', marginBottom: '30px' },
    grid2: { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '30px', marginBottom: '30px' },
    btnMain: { padding: '16px 32px', background: '#1e293b', color: 'white', border: 'none', borderRadius: '12px', fontWeight: 'bold', cursor: 'pointer' },
    btnGhost: { padding: '10px 20px', background: 'white', border: '1px solid #e2e8f0', borderRadius: '10px', cursor: 'pointer', color: '#64748b' }
  };

  const isPartsSale = formData.serviceCategory === '부품판매';

  return (
    <div style={styles.card}>
      <div style={styles.sectionTitle}>{isEditing ? '✏️ 내역 수정' : '📋 신규 접수 등록'}</div>
      <form onSubmit={handleRegister}>
        <div style={{ marginBottom: '30px', padding: '20px', background: isPartsSale ? '#fefce8' : '#eff6ff', borderRadius: '12px', border: isPartsSale ? '1px solid #fef08a' : '1px solid #bfdbfe', display: 'flex', gap: '30px', alignItems: 'center' }}>
          <span style={{ fontSize: '15px', fontWeight: '800', color: '#1e293b' }}>접수 유형 선택</span>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontWeight: 'bold' }}>
            <input type="radio" name="serviceCategory" value="정비" checked={!isPartsSale} onChange={() => setFormData({...formData, serviceCategory: '정비', repairType: '유상'})} /> 
            🛠️ 차량 정비 접수
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontWeight: 'bold' }}>
            <input type="radio" name="serviceCategory" value="부품판매" checked={isPartsSale} onChange={() => setFormData({...formData, serviceCategory: '부품판매', repairType: '부품', carNumber: '', vin: '', mileage: '', symptom: '', inspection: ''})} /> 
            📦 단순 부품 판매 (차량정보 생략)
          </label>
        </div>

        <div style={styles.grid4}>
          <div><label style={styles.label}>1. 고객명 (필수)</label>
            <input type="text" list="customers-list" style={styles.input} placeholder="고객명 검색 선택" value={formData.customerName}
              onChange={e=>{ const val = e.target.value; const c = customers.find(item=>item.name===val); const v = vehicles.find(item=>item.carNumber===(c?c.carNumber:'')); setFormData({...formData, customerName: val, carNumber: c ? c.carNumber : '', vin: v ? v.vin : ''}); }} required />
            <datalist id="customers-list">{customers.map(c=>(<option key={c.id} value={c.name}>{c.name} ({c.carNumber || '등록차량 없음'})</option>))}</datalist>
          </div>
          <div><label style={styles.label}>2. 차량번호</label>
            <input type="text" list="vehicles-list" style={{...styles.input, background: isPartsSale ? '#f1f5f9' : '#fff'}} placeholder="차량번호" value={formData.carNumber}
              onChange={e=>{ const val = e.target.value; const v = vehicles.find(item=>item.carNumber===val); setFormData({...formData, carNumber: val, vin: v ? v.vin : formData.vin, customerName: v ? (v.customerName || formData.customerName) : formData.customerName}); }} disabled={isPartsSale} required={!isPartsSale} />
          </div>
          <div><label style={styles.label}>3. 차대번호(VIN)</label><input style={{...styles.input, background:'#f8fafc'}} value={formData.vin} readOnly disabled={isPartsSale} /></div>
          <div><label style={styles.label}>4. 주행거리 (km)</label><input type="number" style={{...styles.input, background: isPartsSale ? '#f1f5f9' : '#fff'}} value={formData.mileage} onChange={e=>setFormData({...formData, mileage: e.target.value})} disabled={isPartsSale} required={!isPartsSale} /></div>
        </div>

        <div style={styles.grid4}>
          <div>
            <label style={styles.label}>5. 접수/예약 일자 및 시간</label>
            <div style={{ display: 'flex', gap: '8px' }}>
              <input type="date" style={{ ...styles.input, flex: 1.3 }} value={formData.asDate || ''} onChange={e => setFormData({ ...formData, asDate: e.target.value })} required />
              <input type="time" style={{ ...styles.input, flex: 1, padding: '14px 10px' }} value={formData.asTime || ''} onChange={e => setFormData({ ...formData, asTime: e.target.value })} />
            </div>
          </div>
          <div><label style={styles.label}>6. 담당 직원(정비사)</label>
            <select style={styles.input} value={formData.mechanic} onChange={e=>setFormData({...formData, mechanic: e.target.value})} required>
              <option value="">담당자 선택</option>{engineers.map(en=><option key={en.id} value={en.name}>{en.name}</option>)}
            </select>
          </div>
          <div><label style={styles.label}>7. 수리/판매 구분</label>
            <select style={styles.input} value={formData.repairType || '유상'} onChange={e => setFormData({...formData, repairType: e.target.value})}>
              {!isPartsSale && <><option value="유상">유상 수리</option><option value="무상">무상 수리 (보증)</option></>}
              {isPartsSale && <option value="부품">단순 부품 판매</option>}
            </select>
          </div>
          <div><label style={styles.label}>8. 진행 상태</label>
            <select style={styles.input} value={formData.status || '접수'} onChange={e => setFormData({...formData, status: e.target.value})} disabled={!isEditing && false}>
              <option value="예약">예약 (작업대기)</option>
              <option value="접수">접수</option>
              <option value="진행중">진행중 (미수)</option>
              <option value="완료">완료 (수납결제)</option>
              <option value="보류">보류</option>
            </select>
          </div>
        </div>
        
        {!isPartsSale && (
          <>
            <div style={styles.grid2}>
              <div><label style={styles.label}>입고 증상 (또는 예약 시각 및 내용 기재)</label><textarea style={{...styles.input, height:'80px'}} value={formData.symptom} onChange={e=>setFormData({...formData, symptom: e.target.value})} placeholder="예) 오전 10시 브레이크 소음 수리 예정" /></div>
              <div><label style={styles.label}>점검 내역</label><textarea style={{...styles.input, height:'80px'}} value={formData.inspection} onChange={e=>setFormData({...formData, inspection: e.target.value})} /></div>
            </div>
            <div style={styles.grid2}>
              <div><label style={styles.label}>발생 원인</label><textarea style={{...styles.input, height:'80px'}} value={formData.cause} onChange={e=>setFormData({...formData, cause: e.target.value})} /></div>
              <div><label style={styles.label}>조치 내역</label><textarea style={{...styles.input, height:'80px'}} value={formData.action} onChange={e=>setFormData({...formData, action: e.target.value})} /></div>
            </div>
            <div style={{marginBottom:'30px'}}><label style={styles.label}>수리 결과</label><input style={styles.input} value={formData.result} onChange={e=>setFormData({...formData, result: e.target.value})} /></div>
          </>
        )}
        {isPartsSale && (
          <div style={{marginBottom:'30px'}}><label style={styles.label}>부품 판매 비고란 (납품처 등 기재)</label><input style={styles.input} value={formData.result} onChange={e=>setFormData({...formData, result: e.target.value})} placeholder="예) 서울교통공사 납품 건" /></div>
        )}
        
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
          <div style={{display:'flex', gap:'15px'}}>
            <button type="submit" style={styles.btnMain}>{isEditing ? "내용 수정 완료" : (isPartsSale ? "부품 판매 접수하기" : "AS 정비 접수하기")}</button>
            <button type="button" onClick={()=>{ setViewMode('LIST'); setIsEditing(false); }} style={styles.btnGhost}>취소</button>
          </div>
          {isEditing && ['진행중', '보류', '완료'].includes(formData.status) && (
            <button type="button" onClick={(e) => { e.preventDefault(); setViewMode('SETTLE'); window.scrollTo(0, 0); }} style={{ ...styles.btnMain, background: '#10b981' }}>💰 부품단가/정산 입력하기 ➔</button>
          )}
        </div>
      </form>
    </div>
  );
};

export default AsRegister;